<template>
<div class="system-set rule-list">
  <div class="m-b-20">
    <router-link class="btn-link-large add-btn" style="border-radius: 17px;" to="/home/administrative/rule-add">
      <i class="el-icon-plus"></i>&nbsp;&nbsp;添加节点
    </router-link>
  </div>
  <el-table
  :data="tableData"
  style="width: 100%"
  class="showName"
  @selection-change="selectItem">
    <el-table-column
    type="selection"
    :context="_self"
    width="50">
    </el-table-column>
    <el-table-column
    prop="p_title"
    label="节点结构"
    width="">
    </el-table-column>
    <el-table-column
    prop="title"
    width="200"
    label="显示名">
    </el-table-column>
    <el-table-column
    prop="name"
    label="名称"
    width="">
    </el-table-column>
    <el-table-column
    label="状态"
    width="100">
      <template slot-scope="scope">
        {{ nowStatus[scope.row.status] }}
      </template>
    </el-table-column>
    <el-table-column
    label="操作"
    width="200">
      <template slot-scope="scope">
        <div>
          <span>
            <router-link :to="{ name: 'ruleEdit', query: { id: scope.row.id }}" class="btn-link edit-btn">
            编辑
            </router-link>
          </span>
          <span>
            <el-button
            size="small"
            type="danger"
            @click="confirmDelete(scope.row)">
            删除
            </el-button>
          </span>
        </div>
      </template>
    </el-table-column>
  </el-table>
  <div class="pos-rel p-t-20" style="text-align: left;padding-top: 10px">
    <el-button size="small" @click="changeAttrInBtnGroup(1)">启用</el-button>
    <el-button size="small" @click="changeAttrInBtnGroup(0)">禁用</el-button>
    <el-button size="small" @click="deleteDatasInBtnGroup()">删除</el-button>
  </div>
</div>
</template>

<script>
import { getWithInList, useBanRules, deleteRules, deleteRule } from '@/api/customer.js'
export default {
  data() {
    return {
      tableData: [{}],
      multipleSelection: [],
      nowStatus: {
        0: '禁用',
        1: '启用'
      }
    }
  },
  methods: {
    // 多选
    selectItem(val) {
      let ids = []
      for (let item of val) {
        ids.push(item.id)
      }
      this.multipleSelection = ids
    },
    // 多选启用禁用
    changeAttrInBtnGroup(status) {
      if (this.multipleSelection.length > 0) {
        useBanRules(this.multipleSelection, status).then((res) => {
          if (res.data.code === 0) {
            _g.toastMsg('success', res.data.error)
            this.getRules()
          }
        })
      } else {
        _g.toastMsg('error', '请选择权限')
      }
    },
    // 多选删除
    deleteDatasInBtnGroup() {
      this.$confirm('确认删除这些权限?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteRules(this.multipleSelection).then((res) => {
          if (res.data.code === 0) {
            _g.toastMsg('success', res.data.error)
            this.getRules()
          }
        })
      }).catch((error) => {
      })
    },
    // 单个删除权限
    confirmDelete(item) {
      this.$confirm('确认删除该权限?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteRule(item.id).then((res) => {
          if (res.data.code === 0) {
            _g.toastMsg('success', res.data.error)
            this.getRules()
          }
        })
      }).catch((error) => {
      })
    },
    // 获取权限列表
    getRules() {
      getWithInList().then((res) => {
        if (res.data.code === 0) {
          this.tableData = res.data.data.list
        }
      })
    }
  },
  created() {
    this.getRules()
  },
  computed: {
    addShow() {
      return _g.getHasRule('rules-save')
    },
    editShow() {
      return _g.getHasRule('rules-update')
    },
    deleteShow() {
      return _g.getHasRule('rules-delete')
    }
  },
  components: {
  }
}
</script>
